import BaseLayer from 'ol/layer/Base';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, effect, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import GeoJSON from 'ol/format/GeoJSON';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import { map, withLatestFrom } from 'rxjs';
import { AppService } from '../../../../services/app.service';
import { MapService } from '../../../../services/map.service';
import { selectCounties } from '../../../../state/location/location.reducer';
import { BaseUILayer } from '../../../classes/layers/base-ui-layer';
import { CountySrcPopupComponent } from '../../../layer-popups/county-src-popup/county-src-popup.component';
import { LayerHeaderComponent } from '../../layer-header/layer-header.component';

@Component({
  selector: 'tgrid-county-src-layer',
  imports: [
    LayerHeaderComponent,
  ],
  templateUrl: './county-src-layer.component.html',
  standalone: true,
  styleUrl: './county-src-layer.component.scss',
})
export class CountySrcLayerComponent extends BaseUILayer<BaseLayer> {

  private appService = inject(AppService);
  private store = inject(Store);
  private http = inject(HttpClient);

  constructor() {
    super();

    effect(() => {
      this.appService.selectedStates();
      if (this.checked) {
        this.toggleLayer(this.checked);
      }
    });
  }


  override toggleLayer(checked: boolean): void {
    this.checked = checked;
    if (this.checked) {
      this.getData();
    } else {
      MapService.getMapRef()!.removeLayer(this.mapLayer().renderedLayer);
    }
  }

  override onDestroy(): void {
  }

  private getData(): void {
    const url = '/api/metrics/src-curve-info';
    let params = new HttpParams();
    const states = this.appService.selectedStates();
    const stateAbbreviations = states.map(s => s.abbreviation).join(',');
    const stateIds = states.map(s => s.id);

    params = params.set('state', stateAbbreviations);


    this.http.get<{fipsCode: string}[]>(url, { params }).pipe(
      map(srcInfo => srcInfo.map(i => i.fipsCode)),
      withLatestFrom(this.store.select(selectCounties)),
      map(([validFips, counties]) => {
        return counties
          .filter(county => stateIds.includes(county.stateId))
          .map(county => {
            return {
              type: 'Feature',
              geometry: JSON.parse(county.boundary),
              properties: {
                ...county,
                'popoverComponent': CountySrcPopupComponent,
                hasData: validFips.includes(county.geoid),
              },
            };
          });
      }),
    )
      .subscribe(counties => {
        const features = new GeoJSON().readFeatures({ type: 'FeatureCollection', features: counties });

        if (this.mapLayer().renderedLayer && this.mapService.isLayerOnMap(this.mapLayer().renderedLayer)) {
          (this.mapLayer().renderedLayer as VectorLayer<VectorSource>).getSource()?.clear();
          (this.mapLayer().renderedLayer as VectorLayer<VectorSource>).getSource()?.addFeatures(features as Feature<Geometry>[]);
          return;
        }

        this.mapLayer().renderedLayer = new VectorLayer({
          source: new VectorSource({
            features: features as Feature<Geometry>[],
            attributions: this.mapLayer().buildAttribution(),
          }),
          properties: {
            name: this.mapLayer().displayName,
          },
          opacity: 0.8,
          style: (feature) => {
            return new Style({
              stroke: new Stroke({
                color: 'black',
                width: 1,
              }),
              fill: new Fill({
                color: (feature.getProperties()['hasData']) ? '#96B6F3' : '#444',
              }),
            });

          },
        });

        MapService.getMapRef()!.addLayer(this.mapLayer().renderedLayer);
      });


  }

}
